/* ==========================================================================
   PanelAccommodationPackages > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { initRooms } = require('./rooms');
const { initDiscounts } = require('./discounts');
const baseConfig = require('./config');

/**
 * PanelAccommodationPackages component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function PanelAccommodationPackages(
    selector = '[data-component="PanelAccommodationPackages"]',
    configuration = {}
) {
    if (elementExist(selector)) {
        // Instance reference
        const instance = {};

        // Config
        instance.config = { ...baseConfig, ...configuration };

        // Element reference
        instance.element = document.querySelector(selector);

        // Selector reference
        instance.selector = selector;

        // Literals
        instance.literals = JSON.parse(instance.element.dataset.literals) || false;

        // Init Counter: adults, children
        initRooms(instance);

        // Init resident discounts and bonuses
        initDiscounts(instance);

        return instance;
    }
};
